// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item_77d2ce1e {
  cursor: pointer;
  padding: 0 1.334rem;
  font-family: PitchBookFont, 'Helvetica', 'Arial', sans-serif;
  font-size: 1rem;
  line-height: 1;
  letter-spacing: normal;
  font-stretch: normal;
  height: 2.667rem;
  border: 0.084rem solid transparent;
  background-color: transparent;
  margin: 0;
  white-space: nowrap;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 2.667rem;
}
.item_77d2ce1e.item__highlighted_77d2ce1e:not(.item_disabled_77d2ce1e) {
  color: #fff;
  background-color: #1d5080;
  border-color: #1d5080;
}
.item_77d2ce1e.item__highlighted_77d2ce1e:not(.item_disabled_77d2ce1e) + .separated_77d2ce1e {
  border-color: transparent;
}
.item_77d2ce1e.item__highlighted_77d2ce1e:not(.item_disabled_77d2ce1e) .caption_77d2ce1e {
  font-weight: 600;
}
.item_77d2ce1e.item__highlighted_77d2ce1e:not(.item_disabled_77d2ce1e) .menu-item-meta_77d2ce1e {
  color: inherit;
}
.item_disabled_77d2ce1e {
  cursor: default;
  color: #c1c8cd;
  background-color: #eaedef;
  border-color: transparent;
}
.item_disabled_77d2ce1e .caption_77d2ce1e {
  font-weight: 400;
}
.item_disabled_77d2ce1e .menu-item-meta_77d2ce1e {
  color: inherit;
}
.item_disabled_77d2ce1e:focus,
.item_disabled_77d2ce1e:active,
.item_disabled_77d2ce1e:hover {
  cursor: default;
  color: #c1c8cd;
  background-color: #eaedef;
  border-color: transparent;
}
.item_disabled_77d2ce1e:focus .caption_77d2ce1e,
.item_disabled_77d2ce1e:active .caption_77d2ce1e,
.item_disabled_77d2ce1e:hover .caption_77d2ce1e {
  font-weight: 400;
}
.item_disabled_77d2ce1e:focus .menu-item-meta_77d2ce1e,
.item_disabled_77d2ce1e:active .menu-item-meta_77d2ce1e,
.item_disabled_77d2ce1e:hover .menu-item-meta_77d2ce1e {
  color: inherit;
}
.selected_77d2ce1e {
  background-color: #eaedef;
}
.separator_77d2ce1e {
  border: none;
  border-top: 1px solid #dce1e5;
  margin: 0;
}
.caption_77d2ce1e {
  position: relative;
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  min-width: 0;
}
.caption_77d2ce1e::before {
  content: attr(data-hover);
  font-weight: 600;
  visibility: hidden;
}
.caption_77d2ce1e > span {
  position: absolute;
  left: 0;
  top: 0;
}
.icon_77d2ce1e {
  margin-right: 0.667rem;
  position: relative;
  line-height: 1;
  white-space: nowrap;
}
.icon_77d2ce1e.right_77d2ce1e {
  margin-right: 0;
  margin-left: 0.667rem;
}
.list_77d2ce1e {
  padding: 0.334rem 0;
}
.floating_77d2ce1e {
  display: grid;
  grid-template-rows: 1fr;
}
.menu-item-meta_77d2ce1e {
  margin-left: 1.334rem;
  color: #84919b;
  text-transform: uppercase;
  white-space: nowrap;
}
.menu-item-meta_77d2ce1e + .menu-item-meta_77d2ce1e {
  text-align: right;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `item_77d2ce1e`,
	"item__highlighted": `item__highlighted_77d2ce1e`,
	"item_disabled": `item_disabled_77d2ce1e`,
	"separated": `separated_77d2ce1e`,
	"caption": `caption_77d2ce1e`,
	"menu-item-meta": `menu-item-meta_77d2ce1e`,
	"selected": `selected_77d2ce1e`,
	"separator": `separator_77d2ce1e`,
	"icon": `icon_77d2ce1e`,
	"right": `right_77d2ce1e`,
	"list": `list_77d2ce1e`,
	"floating": `floating_77d2ce1e`
};
export default ___CSS_LOADER_EXPORT___;
